import { api, setTokens, clearTokens } from "./api";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface AuthTokens {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export interface UserProfile {
  id: number;
  name: string;
  email: string;
  role_id: number;
  is_active: boolean;
  phone: string | null;
  client_id: number | null;
  avatar_url: string | null;
  join_date: string;
  last_active: string | null;
  created_at: string;
  updated_at: string | null;
  role_name: string;
  department_name: string;
  client_name: string | null;
  permissions?: string[];
}

/** Users whose role belongs to the Client department should use the public portal UI. */
const CLIENT_DEPT_KEYS = new Set(["client", "cliente", "clients", "clientes"]);

export function isClientDepartmentUser(user: UserProfile | null): boolean {
  if (!user) return false;
  const n = (user.department_name || "").trim().toLowerCase();
  return CLIENT_DEPT_KEYS.has(n);
}

export const authService = {
  async login(data: LoginRequest): Promise<AuthTokens> {
    const res = await api.post<AuthTokens>("/auth/login", data);
    setTokens(res.access_token, res.refresh_token);
    return res;
  },

  async logout(): Promise<void> {
    try {
      await api.post("/auth/logout");
    } finally {
      clearTokens();
    }
  },

  async me(): Promise<UserProfile> {
    return api.get<UserProfile>("/auth/me");
  },

  /** Portal JWT for client-department users with a matching Contact email (after admin /login). */
  async exchangePortalToken(): Promise<{
    access_token: string;
    contact_id: number;
    contact_name: string;
    client_id: number;
    client_name: string;
  }> {
    return api.get("/auth/exchange-portal-token");
  },
};
